
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 70 70","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M60.865 9.695c-1.68-1.19-3.955-.945-5.6.735-3.64 3.745-7.21 7.525-10.78 11.305-.98 1.05-1.75 2.345-1.225 3.71.49 1.365-.21 1.995-.91 2.94-1.4 1.925-2.975 2.59-5.11 1.225-.665-.42-1.12-.21-1.645.35a245.806 245.806 0 01-4.165 4.375l-2.065-2.065c-2.66-2.52-5.32-5.075-8.015-7.595-1.785-1.68-3.99-1.05-4.655 1.295-3.045 10.5-6.055 20.965-9.1 31.465-.315 1.12-.21 2.135.7 2.94.84.77 1.82.805 2.87.455l30.765-10.5c2.59-.875 3.08-3.08 1.12-4.97-2.975-2.87-5.985-5.705-8.995-8.575-.28-.28-.595-.56-.945-.91.56-.595 1.12-1.015 1.47-1.575 1.4-2.135 3.115-2.73 5.355-1.33.56.35.945.14 1.365-.315 1.085-1.225 2.24-2.38 3.395-3.535.245-.245.735-.49 1.015-.42 1.995.63 3.5 0 4.9-1.47 3.43-3.675 6.93-7.28 10.36-10.92.42-.42.84-.91 1.12-1.435.945-1.785.385-4.025-1.225-5.18zM23.73 45.465c-.49-.455-.945-.91-1.54-1.47.49-.525.945-1.015 1.47-1.54.49.49.98.945 1.54 1.47-.49.49-.945.98-1.47 1.54zM27.3 42c-.56-.525-1.05-.98-1.61-1.54.21-.245.455-.525.7-.805 1.155-1.225 2.31-2.415 3.465-3.64l1.61 1.61c-1.33 1.4-2.73 2.87-4.165 4.375zm32.41-27.58c-1.785 1.96-3.64 3.85-5.495 5.775-1.82 1.89-3.605 3.815-5.425 5.67-.98 1.015-2.17 1.05-2.975.105-.665-.77-.665-1.75.105-2.555 3.675-3.885 7.35-7.77 11.06-11.62.77-.805 1.89-.805 2.66-.105.875.735.91 1.82.07 2.73z","fill":"#27AE60"}})])
          )
        }
      }
    